import GridColumns from './columns';
import GridRows from './rows';
import GridColumnsEditors from './editors';
import KeyboardNavigation from './keyboardNavigation';
import Dnd from './dnd';
import WebixContextMenu from './webixContextMenu';
import MassChangeContextMenu from './massChangeContextMenu';
import MassChangeSelectMenu from './massChangeSelectMenu';

export default {
  init(instance, projectConfig) {
    GridColumns.init(instance, projectConfig); // Initing grid columns and columns config
    GridColumnsEditors.init(instance, projectConfig); // Initing editor types and attaching them to columns
    GridRows.init(instance); // Add custom row render and includes task click handler
    Dnd.init(instance);
    KeyboardNavigation.init(instance);
    WebixContextMenu.init(instance);
    MassChangeContextMenu.init(instance);
    MassChangeSelectMenu.init(instance);
  },

  initForExport(instance, projectConfig) {
    GridColumns.init(instance, projectConfig);
    GridRows.init(instance);
  },
};
